import {h, Component} from 'preact';

class UEStatusBadge extends Component {
    static defaultProps = {
        size: 184,
        currentRank: null // oneOf(['bronze','silver','gold','platinum])
    };

    render ( {currentRank, size} ) {
        if ( !currentRank ) {
            return;
        }

        const status = currentRank.toLowerCase();

        return (
            <svg className={`fade-in fill-current-color text-${status || 'black'}`}
                 height={size}
                 width={size}>
                <use xlinkHref={`/svg/logos-defs.svg#icon-ue-status-${status}`}></use>
            </svg>
        );
    }
}

export default UEStatusBadge;
